import {
  defineStore
} from 'pinia';

export const useMianStore = defineStore('main', {
  state: () => {
    return {
      styleColor: "#63A0FF"
    };
  },
  getters: {
    nameLength: (state) => state.name.length,
  },
  actions: {
    updateName(name) {
      this.name = name;
    },
  },
});